export const calendarType = {
    MEETING: 'CALENDAR_TYPE_MEETING',
    HOLYDAY: 'CALENDAR_TYPE_HOLYDAY',
    GROUP: 'CALENDAR_TYPE_GROUP_TIMEFRAME',
    BIRTHDAY: 'CALENDAR_USER_BIRTHDAY',
    STUDENT_TEST: 'CALENDAR_TYPE_STUDENT_TEST',
};